import type { MutableRefObject } from 'react'

const EXTERNAL_LOADING_START_GRACE_MS = 300
const EXTERNAL_LOADING_POLL_MS = 50
const EXTERNAL_LOADING_MAX_WAIT_MS = 120_000

function delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function waitForExternalLoading(isLoadingRef: MutableRefObject<boolean | undefined>): Promise<void> {
    const deadline = Date.now() + EXTERNAL_LOADING_MAX_WAIT_MS
    const graceEnd = Date.now() + EXTERNAL_LOADING_START_GRACE_MS

    while (Date.now() < graceEnd && !isLoadingRef.current) {
        await delay(10)
    }

    while (isLoadingRef.current) {
        if (Date.now() >= deadline) {
            return
        }
        await delay(EXTERNAL_LOADING_POLL_MS)
    }
}
